import React from 'react';
import { BLOGS } from '../../data/portfolio';

const Blogs: React.FC = () => (
  <div className="page">
    <header>
      <h2>
        blogs <span>{BLOGS.length} on medium</span>
      </h2>
      <p>Notes from building systems and thinking about how they behave.</p>
    </header>
    <div className="bloglist">
      {BLOGS.map((p) => (
        <a
          key={p.id}
          className="post"
          href={p.url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="post-meta">
            <time dateTime={p.date}>{p.date}</time>
            <span className="dim">·</span>
            <span className="dim">{p.read}</span>
          </div>
          <h3>
            {p.title}
            {p.isNew ? <span className="tag-new">new</span> : null}
          </h3>
          <p>{p.summary}</p>
          <div className="post-tags">
            {p.tags.map((t) => (
              <span key={t}>{t}</span>
            ))}
          </div>
        </a>
      ))}
    </div>
  </div>
);

export default Blogs;
